import React from "react";
import { Button, Form, Modal } from "react-bootstrap";

const UploadAndListingPickupLocationModal = ({
  pickupLocationModal,
  setPickupLocationModal,
  setAddress,
  address,
  handleClose,
  handleSubmit,
  errorMessagePickup,
  setErrorMessagePickup,
  pickupLocationData,
  
}) => {
  return (
    <>
      <Modal show={pickupLocationModal} onHide={handleClose} backdrop="static">
        <Modal.Header className="add-address-close-icon" closeButton>
          <Modal.Title className="shipping-address-heading">
            Add PickUp Location
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className="add-Address-main-container">
            <Form.Group controlId="formMobile">
              <Form.Label>
                10-digit Mobile Number <span>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter 10-digit mobile number"
                name="mobile"
                value={address.phoneNumber}
                onChange={(e) => {
                  setAddress({
                    ...address,
                    phoneNumber: e?.target?.value,
                  });
                  setErrorMessagePickup({
                    ...errorMessagePickup,
                    phoneNumber: "",
                  });
                }}
                maxLength={10}
              />
              {errorMessagePickup?.phoneNumber ? (
                <div className="validation-message">
                  {errorMessagePickup?.phoneNumber}
                </div>
              ) : null}
            </Form.Group>

            <Form.Group controlId="formPincode">
              <Form.Label>
                Pincode <span>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter pincode"
                name="pincode"
                value={address.pinCode}
                onChange={(e) =>{
                    setAddress({
                        ...address,
                        pinCode: e?.target?.value,
                      });
                    setErrorMessagePickup({
                        
                        ...errorMessagePickup,
                        pinCode: "",
                      });
                }
                  
                }
              />
               {errorMessagePickup?.pinCode ? (
                <div className="validation-message">
                  {errorMessagePickup?.pinCode}
                </div>
              ) : null}
            </Form.Group>
            <Form.Group controlId="formAddress">
              <Form.Label>
                Address (Area and Street/House No.) <span>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your address"
                name="address"
                value={address.areaAndStreet}
                onChange={(e) =>{
                    setAddress({
                        ...address,
                        areaAndStreet: e?.target?.value,
                      })

                    setErrorMessagePickup({
                        
                        ...errorMessagePickup,
                        areaAndStreet: "",
                      });
                }
                 
                }
              />
               {errorMessagePickup?.areaAndStreet ? (
                <div className="validation-message">
                  {errorMessagePickup?.areaAndStreet}
                </div>
              ) : null}
            </Form.Group>
            <Form.Group controlId="formLocality">
              <Form.Label>
                Locality <span>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter locality"
                name="locality"
                value={address.locality}
                onChange={(e) =>{
                    
                    setErrorMessagePickup({
                        
                        ...errorMessagePickup,
                        locality: "",
                      });
                    setAddress({
                        ...address,
                        locality: e?.target?.value,
                      })
                }
                 
                }
              />
              {errorMessagePickup?.locality ? (
                <div className="validation-message">
                  {errorMessagePickup?.locality}
                </div>
              ) : null}
            </Form.Group>
            <Form.Group controlId="formCity">
              <Form.Label>
                City <span>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter city"
                name="city"
                value={address.city}
                onChange={(e) =>{
                   
                      setAddress({
                        ...address,
                        city: e?.target?.value,
                      })
                      setErrorMessagePickup({
                        
                        ...errorMessagePickup,
                        city: "",
                      });
                }
                 
                }
              />
               {errorMessagePickup?.city ? (


                <div className="validation-message">
                  {errorMessagePickup?.city}
                </div>
              ) : null}
            </Form.Group>
            <Form.Group controlId="formState">
              <Form.Label>
                State <span>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter state"
                name="state"
                value={address.state}
                onChange={(e) =>{
                    setErrorMessagePickup({
                        
                        ...errorMessagePickup,
                        state: "",
                      });
                      setAddress({
                        ...address,
                        state: e?.target?.value,
                      })
                }
                 
                }
              />
               {errorMessagePickup?.state ? (


<div className="validation-message">
  {errorMessagePickup?.state}
</div>
) : null}
            </Form.Group>
            <Form.Group controlId="formLandmark">
              <Form.Label>Landmark (Optional)</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter landmark (optional)"
                name="landmark"
                value={address.landmark}
                onChange={(e) =>
                  setAddress({
                    ...address,
                    landmark: e?.target?.value,
                  })
                }
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="Add-address-modal-save-button"
            variant="primary"
            onClick={handleSubmit}
          >
            Add Location
            {/* {!PrefiledData ? " Save address" : "Update address"} */}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UploadAndListingPickupLocationModal;
